import PedidosScreen from './PedidosScreen'
export default PedidosScreen
